function getDesignCategories() {
    var settings = {
        "url": "https://lids.pulseidconnect.com/api/api/DesignCategory/GetDesignCategoriesByExtension?ext=.pxf&locName=Front",
        "method": "GET",
        "timeout": 0,
        "headers": {
            "apikey": "TsYHjBCCiw7AeOQ0MIIhxhLcYAlbBxpX",
              "company": "Lids",
            "content-type": "application/json"
        }
    };

    $.ajax(settings).done(function(response) {
        var isFrench = window.location.href.indexOf('/fr/') > -1;    
        var frenchCategories = {
            "Canada": "Canada",
            "Misc": "Divers",
            "Pop Culture": "Culture Populaire",
            "Vehicles": "Véhicules",
            "States": "États",
            "Occupations": "Professions",
            "Food": "Nourriture",
            "Football": "Football",
            "Gaming": "Jeux vidéo",
            "Holiday": "Fêtes",
            "Animals": "Animaux",
            "Baseball": "Baseball",
            "Basketball": "Basketball",
            "Emoji": "Émoji",
            "Events": "Événements",
            "Fantasy": "Fantaisie",
            "Flags": "Drapeaux",
            "Mascots": "Mascottes",
            "Military": "Militaire",
            "Music": "Musique",
            "Other Sports": "Autres sports",
            "Outdoors": "Plein air",
            "Patriotic": "Patriotique",
            "Pop Phrases": "Phrases populaires",
            "Raised": "En relief",
            "Rescue": "Secours",
            "Shapes and Letters": "Formes et lettres",
            "World Cultures": "Cultures du monde",
            "Partnerships": "Partenariats"
        };

        for (var i = 0; i < response.length; i++) {
            var category_name = response[i]['Name'];
            var category_id = response[i]['Id'];
            
            if (isFrench && frenchCategories[category_name]) {
                category_name = frenchCategories[category_name];
            }

            var categoeyHtml = `
          <li dataid="${category_id}"><span>${category_name}</span></li>`
            $('.category-list-wrapper ul').append(categoeyHtml)
        }
    });
}


$(document).ready(function() {
    var dataID = '';
    $(document).on("click", ".category-list-wrapper ul li", function() {
        dataID = $(this).attr('dataid');
        $('.category-list-wrapper ul li').removeClass('active');
        $(this).addClass('active');
        getDesignsById(dataID)
        $('#filter').val('');
        $('.result-msg').hide();
    });

});



function getDesignsById(category_id) {
    var data = {
        "CategoryId": category_id,
        "SearchText": "",
        "Skip": 0,
        "Length": 10000,
        "OrderTypes": ["embroidery-template", "embroidery-free-form"]
    }

    var settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://lids.pulseidconnect.com/api/api/designer/ListAllDesigns",
        "type": "POST",
        "headers": {
            "companyId": "16",
            "apikey": "TsYHjBCCiw7AeOQ0MIIhxhLcYAlbBxpX",
            "companyCode": "Lids"
        },
        "data": data
    }

    $.ajax(settings).done(function(resp) {
        var design_gallery = resp['Designs'];
        setPages(design_gallery.length);
        displayDesign()

        function displayDesign(page = 1) {
            let design_data = "";
            let max = page * 150;
            let min = max - 150;
            // Append Data to design_data Variable
            for (let i = min; i < max; i++) {
                let design = design_gallery[i];
                if (design) {
                    design_data +=
                        `<div class="block__gallery-info">
                            <div class="block__gallery-image"><img src="${design.DesignPreviewURL}" alt="${design.DesignCategory}" /></div>
                            <h6>${design.Name}</h6>
                        </div>`;
                } else {
                    break;
                }
            }
            $('#designGallery').html(design_data);
        }
        $('#error-msg').hide();
        $("#filter").keyup(function(e) {
            e.preventDefault();
            var filter = $(this).val().toUpperCase(),
                newCount = 0;
            if (filter.length == 0) {
                setPages(design_gallery.length);
                displayDesign();
            }
            if (filter.length >= 4) {
                $('#error-msg').hide();
                var newDesignName = '';
                var design_data = '';
                for (let i = 0; i < design_gallery.length; i++) {
                    var newDesigngallery = design_gallery[i];
                    newDesignName = newDesigngallery.Name.toUpperCase();
                    if (newDesignName.toUpperCase().indexOf(filter) > -1) {
                        if (newDesigngallery) {
                            design_data +=
                                `<div class="block__gallery-info">
                          <div class="block__gallery-image"><img src="${newDesigngallery.DesignPreviewURL}" alt="${newDesigngallery.DesignCategory}" /></div>
                          <h6>${newDesigngallery.Name}</h6>
                      </div>`;
                            newCount++;

                        } else {
                            break;

                        }
                    }
                }
                if (newCount == 0) {
                    $('.custom-pagination').hide();
                    $('.result-msg').show();
                } else {
                    $('.result-msg').hide();
                }
                $('.custom-pagination').hide();
                setPages(newCount);
                displayDesign()
                $('#designGallery').html(design_data);
            } else {
                $('#error-msg').show();
            }

            if (filter.length == 0) {
                $('#error-msg').hide();
                setPages(design_gallery.length);
                displayDesign();
                $('.custom-pagination').show();
                $('.result-msg').hide();
            }

        });

        function setPages(newLength) {
            let nbPages = Math.ceil(newLength / 204);
            let pages = "";
            let curPage = 1;
            for (let i = 1; i <= nbPages; i++) {
                pages += '<button type="button" data-index="' + i + '" class="pagination-btn" >' + i + '</button>';

                function nextPage(curPage) {
                    if ((curPage * nbPages) < newLength) curPage++;
                    if (curPage == nbPages) {
                        $('.next').css('pointer-events', 'none');
                    }
                    $(".pagination-btn").removeClass('active');
                    $(".pagination-btn[data-index='" + curPage + "']").addClass('active');
                    displayDesign(curPage)
                }

                function previousPage(curPage) {
                    if (curPage > 1) curPage--;
                    $(".pagination-btn").removeClass('active');
                    $(".pagination-btn[data-index='" + curPage + "']").addClass('active');
                    if (curPage != nbPages) {
                        $('.next').css('pointer-events', 'auto');
                    }
                    displayDesign(curPage)
                }
            }
            var prevText = `
          <li class="prev">
            <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 8L10 12L14 16" stroke="#200E32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </li>`;
            var nextText = `
          <li class="next">
            <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 16L14 12L10 8" stroke="#200E32" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </li>`
            $('.custom-pagination-prev').html(prevText);
            $('.custom-pagination-next').html(nextText);
            $('#pages').html(pages);
            $(".pagination-btn[data-index='1']").addClass('active');

            $('.pagination-btn').click(function() {
                var index = $(this).attr('data-index');
                displayDesign(index)
                $(".pagination-btn").removeClass('active');
                $("html, body").animate({ scrollTop: 0 }, "slow");
                $(this).addClass('active')
                if (index == nbPages) {
                    $('.next').css('pointer-events', 'none');
                } else {
                    $('.next').css('pointer-events', 'auto');
                }
            });

            $('.next').click(function() {
                curPage = $(".pagination-btn.active").attr('data-index');
                $("html, body").animate({ scrollTop: 0 }, "slow");
                nextPage(curPage);
            });
            $('.prev').click(function() {
                curPage = $(".pagination-btn.active").attr('data-index');
                $("html, body").animate({ scrollTop: 0 }, "slow");
                previousPage(curPage);
            });
        }
    })
}

getDesignCategories();
getDesignsById();